import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import globalComponents from './global-components'
import utils from './utils'
import './libs'
import Particles from "particles.vue3"

// SASS Theme
import './assets/sass/app.scss'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(Particles)

globalComponents(app)
utils(app)

app.mount('#app')
